import React, { useEffect, useRef, useState } from 'react';

const CustomScrollbar = () => {
    const scrollbarRef = useRef(null);
    const thumbRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        let hideTimeout;
        const thumbElement = thumbRef.current;

        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
            const progress = (scrollTop / scrollHeight) * 100;

            setScrollProgress(Math.round(progress));

            // Atualizar posição do thumb
            if (thumbRef.current && scrollbarRef.current) {
                const scrollbarHeight = scrollbarRef.current.clientHeight;
                const thumbHeight = (window.innerHeight / document.documentElement.scrollHeight) * scrollbarHeight;
                const thumbTop = (scrollTop / document.documentElement.scrollHeight) * scrollbarHeight;

                thumbRef.current.style.height = `${Math.max(thumbHeight, 30)}px`;
                thumbRef.current.style.top = `${thumbTop}px`;
            }

            // Mostrar scrollbar
            setIsVisible(true);

            // Esconder após 2 segundos de inatividade
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => {
                if (!isDragging) {
                    setIsVisible(false);
                }
            }, 2000);
        };

        const handleMouseDown = (e) => {
            setIsDragging(true);
            setIsVisible(true);
            document.body.style.userSelect = 'none';
        };

        const handleMouseMove = (e) => {
            if (!isDragging) return;

            const scrollbarRect = scrollbarRef.current.getBoundingClientRect();
            const scrollbarHeight = scrollbarRect.height;
            const mouseY = e.clientY - scrollbarRect.top;
            const scrollPercentage = mouseY / scrollbarHeight;
            const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;

            window.scrollTo({
                top: scrollPercentage * scrollHeight,
                behavior: 'auto'
            });
        };

        const handleMouseUp = () => {
            setIsDragging(false);
            document.body.style.userSelect = '';
        };

        const handleWheel = () => {
            setIsVisible(true);
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => {
                if (!isDragging) {
                    setIsVisible(false);
                }
            }, 2000);
        };

        // Event listeners
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('wheel', handleWheel);
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);

        if (thumbElement) {
            thumbElement.addEventListener('mousedown', handleMouseDown);
        }

        // Initial setup
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('wheel', handleWheel);
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            if (thumbElement) {
                thumbElement.removeEventListener('mousedown', handleMouseDown);
            }
            clearTimeout(hideTimeout);
        };
    }, [isDragging]);

    // Não renderizar se não houver scroll
    const hasScroll = document.documentElement.scrollHeight > window.innerHeight;
    if (!hasScroll) return null;

    return (
        <div 
            ref={scrollbarRef}
            className={`custom-scrollbar ${isVisible ? 'visible' : ''}`}
        >
            <div 
                ref={thumbRef}
                className="custom-scrollbar-thumb"
            >
                <div className="custom-scrollbar-progress">
                    {scrollProgress}%
                </div>
            </div>
        </div>
    );
};

export default CustomScrollbar;

